<div class="modal-header primaryBgColor grayFontColor">
    <h5 class="modal-title">Kind anlegen</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <span ngbAutofocus tabindex="-1"></span>
    <ng-container *ngIf="eltern; else noParent">
        <div class="mb-3">
            <div class="small">Elternteil: {{ eltern.vorname }} {{ eltern.nachname }}</div>
        </div>
        <app-kind-editor [kind]="kind" [(transferleistung)]="transferleistung"></app-kind-editor>
    </ng-container>
    <ng-template #noParent>
        <div class="text-center py-4">
            Bitte zuerst einen Elternteil auswaehlen.
        </div>
    </ng-template>
</div>

<div class="modal-footer">
    <button class="btn scButton" (click)="activeModal.dismiss()">Abbrechen</button>
    <button class="btn pcButton" [disabled]="!eltern || saving" (click)="saveKind()">Speichern</button>
</div>
